import INVENTORY_API_BASE_URL from "../../config/api";

import React, { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./sticker.css";

const Sticker = () => {
  const [data, setData] = useState([]);

    useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setData(response.data);
    });
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <div>
      <h5 className="sticker">
        <h3>Sticker Status</h3>
      </h5> 

      <div>
        <div>
          <div className="Stikercontainer">
            <div className="Stickercontent">
              <Table responsive className="stickertable">
                <thead>
                  <tr>
                    <th>Order ID</th>

                    <th>Date</th>
                    <th>Title</th>
                    <th>Medium</th>
                    <th>Edition</th>
                    <th>SKU</th>

                    <th>Quantity</th>

                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row) => (
                    <React.Fragment key={row.orderid}>
                      {row.updatedQuantity.map((item, index) => (
                        <tr key={index}>
                          {index === 0 && (
                            <>
                              <td>{row.orderid}</td>

                              <td>{formatDate(row.ApprovalDate)}</td>

                              <td>
                                {row.updatedQuantity
                                  .map((item) => item.title)
                                  .map((title, index) => (
                                    <React.Fragment key={index}>
                                      {title}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>
                              <td>
                                {row.updatedQuantity
                                  .map((item) => item.Medium)
                                  .map((Medium, index) => (
                                    <React.Fragment key={index}>
                                      {Medium}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>
                              <td>
                                {row.updatedQuantity
                                  .map((item) => item.edition)
                                  .map((edition, index) => (
                                    <React.Fragment key={index}>
                                      {edition}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>
                              <td>
                                {row.updatedQuantity
                                  .map((item) => item.sku)
                                  .map((sku, index) => (
                                    <React.Fragment key={index}>
                                      {sku}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>

                              <td>
                                {row.updatedQuantity
                                  .map((item) => item.quantity)
                                  .map((quantity, index) => (
                                    <React.Fragment key={index}>
                                      {quantity}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>

                              <td
                                className={
                                  row.Receivedstatus === "Yes"
                                    ? "received-yes"
                                    : "received-no"
                                }
                              >
                                {row.Receivedstatus}
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sticker;
